<template>
  <b-modal
    hide-footer
    id="modal-add-secretary"
    ref="modal-add-secretary"
    size="md"
    title="เพิ่มสิทธิ์การเป็นเลขา"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h3>
              
            </h3>
          </b-col>
          <b-col cols="12">
            <b-form-group label="เป็นเลขาให้กับ">
              <vue-select
                transition=""
                label="text"
                v-model="secretarySelect"
                :options="secretaryOption"
                :clearable="false"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" v-if="level > 1">
            <b-form-group label="จังหวัด">
              <vue-select
                transition=""
                label="text"
                v-model="provinceSelect"
                :options="provinceOptions"
                :clearable="false"                
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col> -->
        </b-row>
        <footer
          id="modal-transfer___BV_modal_footer_"
          class="modal-footer d-flex justify-content-between"
        >
          <button
            type="button"
            class="btn btn-secondary"
            block
            @click="onCancel"
          >
            ยกเลิก
          </button>
          <button type="button" class="btn btn-primary" block @click="onSubmit">
            บันทึก
          </button>
        </footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import * as storeMaster from "@/store/api/master/index.js";

import VueSelect from "vue-select";

import CommonTable from "./commonTableModal";

import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    VueSelect,
    CommonTable,
    BCard,
  },
  props: {},
  data() {
    return {
      level: 1,
      userDepartmentRoleID: null,
      createBy: null,

      secretaryLevelId: null,
      userSecretaryId: null,

      secretaryOption: [], 
      secretarySelect: null, 
    };
  },
  created() {},
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    onShow(user, level) {
      const _this = this

      console.log(
        "onShow",
        user.userDepartmentRoleId,
        user.userId,
        user.roleId,
        level,
      );

      this.level = level;
      this.userDepartmentRoleId = user.userDepartmentRoleId;
      this.roleId = user.roleId;
      this.createBy = user.userId;

      this.initSecretary();
    },
    initSecretary() { 
      const _this = this;

      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {

          var setDataList = [];
          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;
            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          console.log("officerUnique", officerUnique);

          //_this.officers.push(...setDataList);
          _this.secretaryOption = officerUnique;
          _this.secretarySelect= _this.secretaryOption[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    onSubmit() {
      const data = {
        userDepartmentRoleId: this.userDepartmentRoleId,    
        userId: this.secretarySelect !== null ? this.secretarySelect.value : null,
        secretaryLevelId: this.secretaryLevelId,
        createBy: this.createBy,
      };
      this.$emit("handle-submit-add", data);
    },
    onCancel() {
      this.$refs["modal-add-secretary"].hide();
    },
  },
};
</script>

<style></style>
